import { render, staticRenderFns } from "./StatusModalOld.vue?vue&type=template&id=a9471e16&scoped=true&"
import script from "./StatusModalOld.vue?vue&type=script&lang=js&"
export * from "./StatusModalOld.vue?vue&type=script&lang=js&"
import style0 from "./StatusModalOld.vue?vue&type=style&index=0&id=a9471e16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9471e16",
  null
  
)

export default component.exports